import React from "react";
import PageTitle from "../../components/PageTitle/PageTitle";
import '../../../node_modules/react-vis/dist/style.css';
import { XYPlot, LineSeries, VerticalGridLines, HorizontalGridLines, XAxis, YAxis } from 'react-vis';
import DashboardTitle from "../../widgets/DashboardTitle";
import PieChart from "../../components/PieChart";
import themes from "../../themes";
import readFuture from "../../services/readFuture/readFuture";
import moment from "moment";
import Cookies from "universal-cookie";
import getMargine from "../../services/readFuture/getMargine";
import getCache from "../../services/readFuture/getCache";
import GeneralTable from "../../components/GeneralTable";
import { TextField, Button } from "@material-ui/core";
import payFattura from "../../services/payFattura";
import payInvestimento from "../../services/payInvestimento";
import payStipendi from "../../services/payStipendi";
import emettiFattura from "../../services/emettiFattura";
import getPagamento from "../../services/getPagamento";
import payProvvigione from "../../services/payProvvigione";
import payF24 from "../../services/payF24";
import viewOrder from "../../services/viewOrder";

const cookies = new Cookies();
let username = cookies.get('username', { path: '/' });
let token = cookies.get('token', { path: '/' });
export default class Dashboard extends React.Component {

  constructor(props) {
    super(props);

    this.firstRef = React.createRef();

    let sp = '01/' + moment().format('yyyy');
    let t = '01/' + moment().format('yyyy');
    let ep = moment(t, 'MM/yyyy').add(1, 'year').startOf('month').format('MM/yyyy');

    this.state = {
      chartsWidth: window.innerWidth - 380,
      showOldPatrimonio: false,
      showOldUscite: false,
      showOldEntrate: false,
      startPeriod: sp,
      endPeriod: ep,
      isNotStartingNow: false,
    };

  }

  async reload(start, end) {
    this.setState({ isLoading: true });
    this.calculateWidth();

    username = cookies.get('username', { path: '/' });
    token = cookies.get('token', { path: '/' });

    var startDate = '01-' + this.state.startPeriod.replace('/', '-');

    var endDate = moment(this.state.endPeriod, 'MM/yyyy').endOf('month').add(1, 'day').format('DD-MM-yyyy');
    if (start && end) {
      startDate = '01-' + start.replace('/', '-');
      endDate = moment(end, 'MM/yyyy').endOf('month').add(1, 'day').format('DD-MM-yyyy');
    }

    var month = start ? start : moment().format('MM/yyyy');
    this.patrimonio = [];

    this.temps = await readFuture(username, token, 'patrimonio', startDate, endDate);
    var patrimoni = [];
    this.errori = this.temps.errori;

    let years = {};
    this.temps.tabella[0].mesi.forEach((month, index) => {
        let Y = month.split('/')[1]
        if (!Object.keys(years).includes(Y)) {
            years[Y] = []
        }
        years[Y].push(index)
    })

    Object.entries(years).forEach((entry, index)=>{
        let new_key = 'Totale ' + entry[0]
        this.temps.tabella[0].mesi.push(new_key)
        this.temps.tabella[0].patrimoni.push('--')
        this.temps.tabella[0].margini.push('--')
        this.temps.tabella[0].uscite.push('--')
        let totale_anno_uf = 0
        this.temps.tabella[0].uscite_fatture.forEach((uf, index)=>{
            if (!entry[1].includes(index)){
                return
            }
            totale_anno_uf += uf
        })
        totale_anno_uf = Math.round(totale_anno_uf * 100) / 100
        this.temps.tabella[0].uscite_fatture.push(totale_anno_uf)
        let totale_anno_inv = 0
        this.temps.tabella[0].investimenti.forEach((inv, index)=>{
            if (!entry[1].includes(index)){
                return
            }
            totale_anno_inv += inv
        })
        totale_anno_inv = Math.round(totale_anno_inv * 100) / 100
        this.temps.tabella[0].investimenti.push(totale_anno_inv)
        let totale_anno_sp = 0
        this.temps.tabella[0].spese_periodiche.forEach((sp, index)=>{
            if (!entry[1].includes(index)){
                return
            }
            totale_anno_sp += sp
        })
        totale_anno_sp = Math.round(totale_anno_sp * 100) / 100
        this.temps.tabella[0].spese_periodiche.push(totale_anno_sp)
        let totale_anno_tasse = 0
        this.temps.tabella[0].tasse.forEach((t, index)=>{
            if (!entry[1].includes(index)){
                return
            }
            totale_anno_tasse += t
        })
        totale_anno_tasse = Math.round(totale_anno_tasse * 100) / 100
        this.temps.tabella[0].tasse.push(totale_anno_tasse)
        let totale_anno_stipendi = 0
        this.temps.tabella[0].stipendi.forEach((st, index)=>{
            if (!entry[1].includes(index)){
                return
            }
            totale_anno_stipendi += st
        } )
        totale_anno_stipendi = Math.round(totale_anno_stipendi * 100) / 100
        this.temps.tabella[0].stipendi.push(totale_anno_stipendi)
        let totale_anno_somme_uscite = 0
        this.temps.tabella[0].somme_uscite.forEach((su, index)=>{
            if (!entry[1].includes(index)){
                return
            }
            totale_anno_somme_uscite += su
        })
        totale_anno_somme_uscite = Math.round(totale_anno_somme_uscite * 100) / 100
        this.temps.tabella[0].somme_uscite.push(totale_anno_somme_uscite)
        let totale_anno_somme_entrate = 0
        this.temps.tabella[0].somme_entrate.forEach((se, index)=>{
            if (!entry[1].includes(index)){
                return
            }
            totale_anno_somme_entrate += se
        })
        totale_anno_somme_entrate = Math.round(totale_anno_somme_entrate * 100) / 100
        this.temps.tabella[0].somme_entrate.push(totale_anno_somme_entrate)
        let totale_anno_entrate = 0
        this.temps.tabella[0].entrate.forEach((se, index)=>{
            if (!entry[1].includes(index)){
                return
            }
            totale_anno_entrate += se
        })
        totale_anno_entrate = Math.round(totale_anno_entrate * 100) / 100
        this.temps.tabella[0].entrate.push(totale_anno_entrate)
    })

    if (this.temps) {

      this.patrimonio = this.temps.patrimonio ? this.temps.patrimonio : [];
      this.tabella = this.temps.tabella ? this.temps.tabella[0] : [];

      this.tempPat = {
        labels: [],
        values: [],
      }
      this.patrimonio.forEach((p, i) => {
        patrimoni.push(parseFloat(p))
        this.patrimonio[i] = { x: month, y: parseFloat(p) };
        this.tempPat.labels.push(month);
        this.tempPat.values.push(parseFloat(p))
        month = moment(month, 'MM/yyyy').add(1, 'month').format('MM/yyyy');
      });
    } else {
      this.patrimonio = [];
      this.tabella = [];
    }

    this.uscite = await readFuture(username, token, 'uscite', startDate, endDate);
    this.entrate = await readFuture(username, token, 'entrate', startDate, endDate);
    this.entrateLabels = [];
    this.usciteLabels = ["Provvigioni", "Investimenti", "Stipendi"];

    if (this.uscite.length > 0) {
      let tempUscite = [this.uscite[0], this.uscite[1], this.uscite[2]];
      Object.keys(this.uscite[4]).map(key => {
        tempUscite.push(this.uscite[4][key]);
        this.usciteLabels.push(key === 'no_tag' ? 'Fatture' : key);
      });
      tempUscite.push(this.uscite[5])
      this.usciteLabels.push('Tasse');

      this.uscite = tempUscite;
    }

    if (this.entrate) {
      this.entrate.forEach((e, i) => {
        this.entrateLabels.push(e.rif + ': ' + e.cantiere);
        this.entrate[i] = parseFloat(e.totale);
      });
    }

    this.setState({ isLoading: false, showOldPatrimonio: false, showOldEntrate: false, showOldUscite: false, fatturatoError: this.patrimonio.length === 0 ? true : false });
  }

  async componentDidMount() {
    window.addEventListener('resize', () => this.calculateWidth());

    let cache = await getCache(username, token);
    cache.forEach(c => {
      switch (c.tipo) {
        case "patrimonio":
          var month = this.state.startPeriod;
          this.temps = JSON.parse(c.payload);

          this.patrimonio = this.temps.patrimonio;
          this.tabella = this.temps.tabella[0];
          this.errori = this.temps.errori;

          this.tempPat = {
            labels: [],
            values: [],
          }
          this.patrimonio.forEach((p, i) => {
            this.patrimonio[i] = { x: month, y: parseFloat(p) };
            this.tempPat.labels.push(month);
            this.tempPat.values.push(parseFloat(p))
            month = moment(month, 'MM/yyyy').add(1, 'month').format('MM/yyyy');
          });
          this.setState({ showOldPatrimonio: true });
          break;
        case "uscite":
          this.uscite = JSON.parse(c.payload);
          this.usciteLabels = ["Provvigioni", "Investimenti", "Stipendi"];

          let tempUscite = [this.uscite[0], this.uscite[1], this.uscite[3]];
          Object.keys(this.uscite[4]).map(key => {
            tempUscite.push(this.uscite[4][key]);
            this.usciteLabels.push(key === 'no_tag' ? 'Fatture' : key);
          });
          tempUscite.push(this.uscite[5])
          this.usciteLabels.push('Tasse');
          this.uscite = tempUscite;

          this.setState({ showOldUscite: true });
          break;
        case "entrate":
          this.entrate = [];
          this.entrateLabels = [];
          if (c.payload != "null") {
            JSON.parse(c.payload).forEach((e, i) => {
              this.entrateLabels.push(e.rif + ': ' + e.cantiere);
              this.entrate.push(parseFloat(e.totale));
            });
          }
          this.setState({ showOldEntrate: c.payload !== "null" });
          break;
        default:
          break;
      }
    });

    await this.reload();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', () => this.calculateWidth());
  }

  calculateWidth() {
    while (!this.firstRef) { }

    this.setState({ chartsWidth: this.firstRef.current ? this.firstRef.current.offsetWidth - 60 : 0 });
  }

  async getMargine() {
    this.setState({ loadingMargine: true });
    this.margine = await getMargine(username, token);
    this.setState({ loadingMargine: false });
  }

  async finishReminder(reminder) {

    var res = undefined;

    switch (reminder.tipo) {
      case "commessa_fat":
        res = await emettiFattura(username, token, reminder.id);
        break;
      case "commessa_in":
        res = await getPagamento(username, token, reminder.id);
        break;
      case "commessa_prov":
        res = await payProvvigione(username, token, reminder.id);
        break;
      case "commessa_prov_s":
        res = await payProvvigione(username, token, reminder.id);
        break;
      case "investimnento":
        res = await payInvestimento(username, token, reminder.id)
        break;
      case "stipendi":
        res = await payStipendi(username, token, reminder.id);
        break;
      case "F24":
        res = await payF24(username, token, reminder.id);
        break;
      case "fattura":
        res = await payFattura(username, token, reminder.id);
        break;
      case "ordine":
        res = await viewOrder(username, token, reminder.id)
        cookies.set('ordine', reminder.id, { path: '/' });
        window.location.href = '/#/app/edit-ordine';
        break;
      default:
        break;
    }

    if (res.result === 'ok') {
      this.reload();
      return;
    }

    alert('Si è verificato un errore durante l\'elaborazione della richiesta. Per favore, prova più tardi.');
  }

  render() {

    return (
      <>
        <PageTitle title={'Dashboard'} />
        <div style={{ display: 'flex', marginLeft: -10 }}>
          <TextField
            size="small"
            variant="outlined"
            type='text'
            value={this.state.startPeriod}
            style={smallInputStyle}
            onChange={(e) => {
              this.setState({ startPeriod: e.target.value });
            }}
          />

          <img src={require('../../images/next.png')} alt="" style={{ width: 20, height: 20, marginTop: 18, marginLeft: 7, opacity: 0.4 }} />

          <TextField
            size="small"
            variant="outlined"
            type='text'
            value={this.state.endPeriod}
            style={smallInputStyle}
            onChange={(e) => {
              this.setState({ endPeriod: e.target.value });
            }}
          />

          <Button
            onClick={async () => {
              let start = this.state.startPeriod;
              let end = this.state.endPeriod;

              if (end.length !== 7 || !end.includes("/")) {
                alert('Inserire un valore valido per la fine del periodo (MM/YYYY)')
                return
              }

              this.setState({ showOldPatrimonio: true, showOldEntrate: true, showOldUscite: true })
              await this.reload(start, end);

            }}
            style={{ height: 38, marginTop: 9, marginLeft: 10 }}
            variant="contained"
            color="secondary">Aggiorna</Button>

        </div>
        <div>
          {(this.state.showOldFatturato || this.state.showOldEntrate || this.state.showOldUscite) &&
            <div style={{ ...dashboardView, paddingTop: 10, paddingBottom: 10 }}>
              <p style={{ color: 'grey' }}>Aggiornamento dati in corso...</p>
            </div>
          }
          {this.tabella && (
            <div style={dashboardView} ref={this.firstRef}>
              <DashboardTitle icon={require('../../images/table.png')} title="Andamento generale" />
              <GeneralTable tabella={this.tabella} errori={this.errori} />
            </div>
          )}
          {!this.state.isNotStartingNow ? (
            <div style={dashboardView} ref={this.firstRef}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <DashboardTitle icon={require('../../images/andamento.png')} title="Andamento patrimonio" />
                <img src={require('../../images/write.png')} alt="" style={{ width: 20, height: 20, opacity: 0.1, cursor: 'pointer', marginBottom: 15 }} onClick={() => window.location.href = '/#/app/impostazioni'} />
              </div>
              {!this.state.fatturatoError ? (
                <XYPlot height={300} width={this.state.chartsWidth} xType="ordinal" margin={{ left: 80 }} yRange={[230, 20]}>
                  <VerticalGridLines />
                  <HorizontalGridLines />
                  <LineSeries data={this.patrimonio} color={this.state.showOldPatrimonio ? 'lightgrey' : 'green'} />
                  <XAxis />
                  <YAxis style={{ width: 100 }} />
                </XYPlot>
              ) : (
                <div></div>
              )}
            </div>
          ) : (
            <div style={dashboardView} ref={this.firstRef}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <DashboardTitle icon={require('../../images/andamento.png')} title="Andamento patrimonio" />
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginTop: 20 }}>
                <img src={require('../../images/warning.png')} alt="" style={{ width: 50, height: 50, cursor: 'pointer' }} onClick={() => window.location.href = '/#/app/impostazioni'} />
                <p style={{ color: 'darkgrey', fontWeight: 'bold', fontSize: 16, marginLeft: 15 }}>Il calcolo previsionale del patrimonio non può essere eseguito partendo da un mese diverso da quello attuale</p>
              </div>
            </div>
          )}
          
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ ...dashboardView, marginRight: (this.state.chartsWidth/2 - 20) < 300 ? 0 : 5, minHeight: this.state.showOldUscite ? 470 : 420 }}>
              <DashboardTitle icon={require('../../images/uscita.png')} title="Uscite" />
              {this.uscite &&
                <div style={{ opacity: this.state.showOldUscite ? 0.3 : 1 }}>
                  <PieChart labels={this.usciteLabels} data={this.uscite} width={(this.state.chartsWidth - 10) < 300 ? this.state.chartsWidth : (this.state.chartsWidth - 10) - (this.state.chartsWidth * 0.15)} />
                </div>
              }
            </div>
            <div style={{ ...dashboardView, marginLeft: (this.state.chartsWidth / 2 - 20) < 300 ? 0 : 5, minHeight: this.state.showOldEntrate ? 470 : 420 }}>
              <DashboardTitle icon={require('../../images/entrata.png')} title="Entrate" />
              {this.entrate &&
                <div style={{ opacity: this.state.showOldEntrate ? 0.3 : 1 }}>
                  <PieChart labels={this.entrateLabels} data={this.entrate} width={(this.state.chartsWidth - 10) < 300 ? this.state.chartsWidth : (this.state.chartsWidth - 10) - (this.state.chartsWidth * 0.15)} />
                </div>
              }
            </div>
          </div>
          <div style={dashboardView}>
            <DashboardTitle icon={require('../../images/clock.png')} title="Margine" />
            {this.state.loadingMargine ? (
              <p style={{ color: 'grey', marginLeft: 10 }}>Caricamento...</p>
            ) : (
              <>
                {this.margine ? (
                  <h3 style={{ marginLeft: 10, color: 'grey', fontWeight: 'normal' }}>Al momento il patrimonio si azzererà in data: {this.margine.data}</h3>
                ) : (
                  <div style={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <button style={{ backgroundColor: themes.default.palette.primary.main, color: 'white', fontWeight: 'bold', border: '0px', borderRadius: 25, height: 50, paddingLeft: 30, paddingRight: 30, paddingTop: 15, paddingBottom: 15, marginBottom: 40, marginTop: 10, cursor: 'pointer', boxShadow: '0px 2px 4px lightgrey' }} onClick={() => this.getMargine()}>Calcola margine di respiro</button>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </>
    );
  }
}

const dashboardView = {
  backgroundColor: 'white',
  borderRadius: 10,
  padding: 30,
  marginBottom: 10,
  height: '100%',
  width: '100%',
  overflow: 'hidden',
  boxShadow: '0px 2px 4px lightgrey'
}

const inputStyle = {
  borderRadius: 4,
  width: '80%',
  paddingTop: 9,
  paddingBottom: 9,
  paddingInline: 9,
  outlineColor: '#4A4A4A',
  outlineWidth: "thin"
}

const smallInputStyle = {
  borderRadius: 4,
  width: '20%',
  marginLeft: 5,
  paddingTop: 9,
  paddingBottom: 9,
  paddingInline: 9,
  outlineColor: '#4A4A4A',
  outlineWidth: "thin"
}